import { parentescoSituacao } from '@utils';
import {
  commons,
  spouses,
  casoUniaoEstavelIR,
  termoTutelaJudicial,
  specialChild,
  declarationTaxConjuntIR,
  studentUniversity,
} from '../constants';
import { initialValuesGenerator } from '../initialValueGenerator';
import { dynamicRule } from '../rules';

const { constantsParentesco, constantsSituacao } = parentescoSituacao;

export const dependentesIRDocs = () => {
  const rules = {
    anexoRG: dynamicRule('beneficiario'),
    anexoCPF: dynamicRule('beneficiario'),
    anexoComprovanteEscolaridade: dynamicRule('estudante'),
    anexoCertidaoCasamento: dynamicRule('casamentoConjugeSogroAdd'),
    anexoCasoUniaoEstavel: dynamicRule('conviventeAdd'),
    anexoTermoTutelaJudicial: dynamicRule('tutelaAdd'),
    anexoLaudoMedico: dynamicRule('laudoMedicoDependenteAdd'),
  };
  const docs = {
    commons: [...commons],
    [constantsParentesco.CONJUGE]: [...spouses],
    [constantsParentesco.SOGRO]: [...spouses, ...declarationTaxConjuntIR],
    [constantsParentesco.NORA]: [...spouses, ...declarationTaxConjuntIR],
    [constantsParentesco.GENRO]: [...spouses, ...declarationTaxConjuntIR],
    [constantsParentesco.INCAPAZ]: [...specialChild, ...termoTutelaJudicial],
    [constantsParentesco.CONVIVENTE]: [...casoUniaoEstavelIR],
    [constantsParentesco.MENOR_ASSISTIDO]: [...termoTutelaJudicial],
    // casos parentesco + situacao
    // FILHO
    [`${constantsParentesco.FILHO}_${constantsSituacao.ESPECIAL}`]: [
      ...specialChild,
    ],
    [`${constantsParentesco.FILHO}_${constantsSituacao.UNIVERSITARIO}`]: [
      ...studentUniversity,
    ],
    // IRMAO
    [`${constantsParentesco.IRMAO}_${constantsSituacao.MENOR_IGUAL_21}`]: [
      ...termoTutelaJudicial,
    ],
    [`${constantsParentesco.IRMAO}_${constantsSituacao.ESPECIAL}`]: [
      ...termoTutelaJudicial,
      ...specialChild,
    ],
    [`${constantsParentesco.IRMAO}_${constantsSituacao.UNIVERSITARIO}`]: [
      ...termoTutelaJudicial,
      ...studentUniversity,
    ],
    // NETO
    [`${constantsParentesco.NETO}_${constantsSituacao.MENOR_IGUAL_21}`]: [
      ...termoTutelaJudicial,
    ],
    [`${constantsParentesco.NETO}_${constantsSituacao.ESPECIAL}`]: [
      ...termoTutelaJudicial,
      ...specialChild,
    ],
    [`${constantsParentesco.NETO}_${constantsSituacao.UNIVERSITARIO}`]: [
      ...termoTutelaJudicial,
      ...studentUniversity,
    ],
    // BISNETO
    [`${constantsParentesco.BISNETO}_${constantsSituacao.MENOR_IGUAL_21}`]: [
      ...termoTutelaJudicial,
    ],
    [`${constantsParentesco.BISNETO}_${constantsSituacao.ESPECIAL}`]: [
      ...termoTutelaJudicial,
      ...specialChild,
    ],
    [`${constantsParentesco.BISNETO}_${constantsSituacao.UNIVERSITARIO}`]: [
      ...termoTutelaJudicial,
      ...studentUniversity,
    ],
    // ENTEADO
    [`${constantsParentesco.ENTEADO}_${constantsSituacao.ESPECIAL}`]: [
      ...specialChild,
    ],
    [`${constantsParentesco.ENTEADO}_${constantsSituacao.UNIVERSITARIO}`]: [
      ...studentUniversity,
    ],
  };

  const initialValues = initialValuesGenerator(docs);

  return {
    initialValues,
    rules,
    docs,
  };
};
